export const defaultCaptionSizes = {
  base: 18
};
export const defaultCaptionSizesPercentage = {
  base: 100
};

export const maxCaptionSize = defaultCaptionSizes.base * 2;
export const minCaptionSize = defaultCaptionSizes.base;
export const maxCaptionSizePercentage = 200;
export const minCaptionSizePercentage = 100;
const allGreaterThanMin = (increment, size) => size + increment >= minCaptionSize;

const allSmallerThanMax = (increment, size) => size + increment <= maxCaptionSize;

const getCssValue = (element, cssVar) => parseInt(element.style.getPropertyValue(cssVar), 10);
export const getNumericCssVarsValues = element => getCssValue(element, '--font-Size');

export const getAudioVolume = audio => audio.volume();

export const adjustAudioVolume = (audio, step) => {
  const volume = getAudioVolume(audio);
  const adjustedVolume = volume + step >= 0 && volume + step <= 1 ? volume + step : volume;
  const roundedVolume = parseFloat(adjustedVolume.toFixed(1));

  audio.volume(roundedVolume);
};

export const adjustFontSizePercentage = (value, step) => {
  if (value + step >= 100 && value + step <= 200) return value + step;
  return value;
};

const setValuesWithIncrement = (root, increment, size) => {
  if (!allGreaterThanMin(increment, size)) {
    return;
  }
  if (!allSmallerThanMax(increment, size)) {
    return;
  }

  root.style.setProperty('--font-Size', `${size + increment}px`);
};

export const initSubtitleSize = element => setValuesWithIncrement(element, 0, defaultCaptionSizes);

export const resizeCaptionSize = (element, diff) => {
  const size = getNumericCssVarsValues(element);

  if (Number.isNaN(size)) {
    initSubtitleSize(element);
  }
  setValuesWithIncrement(element, diff, getNumericCssVarsValues(element));
};
